<template>
    <div class="login">
       <div class="login-box">
            <div class="title flex justify-center align-center">
            	<div class="logoImg">
            		 <img src="@/assets/image/logo.png" alt=""  class="logo"/>
            		 <span>|</span>
            		 <a href="https://open.work.weixin.qq.com" target="_blank"><img src="https://open.work.weixin.qq.com/service/img?id=ww4244127678d07ae5&t=isp&c=white&s=small" srcset="https://open.work.weixin.qq.com/service/img?id=ww4244127678d07ae5&t=isp&c=white&s=small@2x 2x" referrerpolicy="unsafe-url" alt="企业微信"></a>
            	</div>


               <!-- <p class="tit">企业微信管理后台</p>-->
            </div>
         <!--   <div class="sub-title font-14">抽奖大转盘电脑端</div>-->
         	<div class="longin_tabs">
	 			<el-tabs  v-model="activeName" @tab-click="handleClick" :stretch="true">
				  <el-tab-pane name="admin">
				    <span slot="label"><i class="el-icon-user-solid"></i> 管理员登录</span>
				    <p class="tit">微信或者企业微信扫码登录</p>
				   	<div class="loginBtn">
			           	 <a href="https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=ww4244127678d07ae5&redirect_uri=https%3A%2F%2Fwork-admin.chouchouxia.cn%2F%23%2Fauth&state=&usertype=admin">
			           		<img src="../assets/image/login2.png" srcset="https://open.work.weixin.qq.com/service/img?id=ww4244127678d07ae5&t=login&c=blue&s=medium@2x 2x" referrerpolicy="unsafe-url" alt="企业微信" >
			           	 </a>
		           	</div>

				  </el-tab-pane>
				  <el-tab-pane label="成员登录" name="member">
				  	 <span slot="label"><i class="el-icon-user"></i>成员登录</span>
				  	 <p class="tit">仅支持企业微信扫码登录</p>
			  	 	<div class="loginBtn">
			           	 <a href="https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=ww4244127678d07ae5&redirect_uri=https%3A%2F%2Fwork-admin.chouchouxia.cn%2F%23%2Fauth&state=&usertype=member">
			           		<img src="https://open.work.weixin.qq.com/service/img?id=ww4244127678d07ae5&t=login&c=blue&s=medium" srcset="https://open.work.weixin.qq.com/service/img?id=ww4244127678d07ae5&t=login&c=blue&s=medium@2x 2x" referrerpolicy="unsafe-url" alt="企业微信" >
			           	 </a>
		           	</div>

				  </el-tab-pane>
				</el-tabs>
			</div>
        </div>

        </div>
    </div>
</template>

<script>
import { postAuthLogin } from "../api/login";
import Cookies from "js-cookie";

export default {
  name: 'index',
   components: {

  },
  data () {
    return {
    	qrCode:'',
     	auth_code:'',
     	isSending:false,
     	activeName:'admin'
    }
  },
  methods:{

  },
  created(){
  	Cookies.remove('token');
    Cookies.remove('agent');
    Cookies.remove('usertype');


  },
  methods:{
  	handleClick(e){

  	}
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  type="text/scss" lang="scss" >

	.login {
	    width: 100vw;
	    height: 100vh;
	    position: relative;
	    background-image: url('~@/assets/image/background2.svg');
	    background-size: 100%;
	    .login-box {
	        position: absolute;
	        top: 50%;
	        left: 50%;
	        transform: translate(-50%, -50%);
	        width: 400px;
	        height: 280px;
	        background-color: #ffffff;
	        box-shadow: 0px 0px 56px rgba(0, 0, 0, 0.05);
	        border-radius: 15px;
	        text-align: center;
	        .title {
	            padding-top: 40px;
	            .logoImg{
	            	display: flex;
	            	justify-content:space-around;
	            	align-items: center;
	            	width:60%;
	            	margin:0 auto;
	            	.logo{
	            		width: 66px;
		                height: 37px;
	            	}
	            	span{
	            		color: #ECECEC;
	            	}
	            	a{
	            		img{
	            			display: block;
	            		}
	            	}
	            }


	        }
	        .longin_tabs{
	        	padding: 10px 70px;
	        }
	        .loginBtn{
	        	margin: 20px auto 20px;
	        }
	        .tit{
            	margin: 10px auto;
            	font-size: 12px;
            	color: #999999;
            }
	        .sub-title {
	            padding-top: 15px;
	        }
	        .code-login {
	            padding-top: 20px;
	            .qr-code {
	                position: relative;
	                width: 160px;
	                margin: 30px auto 0;
	                .expire {
	                    flex-direction: column;
	                    color: #fff;
	                    position: absolute;
	                    top: 0;
	                    left: 0;
	                    right: 0;
	                    bottom: 0;
	                    background-color: rgba(0, 0, 0, 0.7);
	                    .icon {
	                        width: 28px;
	                        height: 28px;
	                    }
	                    p {
	                        margin-top: 10px;
	                    }
	                }
	            }
	        }
	    }
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue